import {isFeatureEnabled} from 'feature-flags';

import {featureFlags} from '@dms/feature-flags';

import {refreshDatagrid as refreshLegacyDatagrid} from 'features/datagrid';
import {refreshDatagrid as refreshEagDatagrid} from 'features/eag-grid';

type RefreshDmsDatagridOptions = {
  deselectAll?: boolean;
  /**
   * When true, refreshes row counts displayed on preset buttons.
   * Supported by both legacy DataGrid and EagGrid engines.
   */
  refreshPresetCount?: boolean;
};

/**
 * Refresh a grid by its gridCode.
 * Dispatches the correct custom event depending on which grid engine
 * is active (controlled by the EAG_GRID feature flag).
 */
export const refreshDmsDatagrid = (gridCode: string, options?: RefreshDmsDatagridOptions): void => {
  if (isFeatureEnabled(featureFlags.EAG_GRID)) {
    refreshEagDatagrid(gridCode, options);
  } else {
    refreshLegacyDatagrid(gridCode, options);
  }
};
